module.exports = __webpack_public_path__ + "static/media/signature-icon.111a2372.svg";